define('behavior/select.and.upload.files.behavior',['require','exports','module','underscore','marionette','fine-uploader/all.fine-uploader.core','datakit/datakit','uuid','fukit','view/block/progress.modal.view','fukit','bluebird','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _                      = require('underscore'),
      Mn                     = require('marionette'),
      qq                     = require('fine-uploader/all.fine-uploader.core'),
      DataKit                = require('datakit/datakit'),
      uuid                   = require('uuid'),
      ResolveOptionsBehavior = require('fukit').ResolveOptionsBehavior,
      ProgressModalView      = require('view/block/progress.modal.view'),
      config                 = require('fukit').config,
      Promise                = require('bluebird'),
      Radio                  = require('backbone.radio');

  var SelectAndUploadFilesBehavior = Mn.Behavior.extend({
    defaults: {
      useS3Uploader: true,
      fineUploaderOptions: null,
    },

    onRender: function() {
      this.initializeFineUploader();
    },

    initializeFineUploader: function() {
      var self = this;
      var fineUploaderOptions = Mn._getValue(this.getOption('fineUploaderOptions'), this) || {};
      var userPrincipalModel =
        Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel') || new Backbone.Model();

      var FineUploaderConstructor = this.getOption('useS3Uploader') ? qq.s3.FineUploaderBasic : qq.FineUploaderBasic;

      fineUploaderOptions = ResolveOptionsBehavior.resolveViewValue(fineUploaderOptions, this.view);

      var callbacks = fineUploaderOptions.callbacks || {};

      var token = "Bearer "+ localStorage.getItem('fk_accessToken');


      this.fineUploader = new FineUploaderConstructor(
        _.extend({}, fineUploaderOptions, {
          maxConnections: 3,

          request: _.extend(
            {
              endpoint: this.getConfigValue('aws.s3.{}.endpoint'),
              accessKey: this.getConfigValue('aws.s3.{}.accessKey'),
              customHeaders: {
                Authorization: token,
                "X-IDP-New-Login": true,
              },
            },
            fineUploaderOptions.request
          ),

          signature: _.extend(
            {
              version: 4,
              endpoint: '/api/v1/attachments/s3/sign',
              customHeaders: {
                Authorization: token,
                "X-IDP-New-Login": true,
              },
            },
            fineUploaderOptions.signature
          ),

          uploadSuccess: _.extend(
            {
              endpoint: '/api/v1/attachments/files/completeUpload',
              method: 'PUT',
              customHeaders: {
                Authorization: token,
                "X-IDP-New-Login": true,
              },
            },
            fineUploaderOptions.uploadSuccess
          ),

          chunking: _.extend(
            {
              concurrent: {
                enabled: true,
              },

              partSize: 5 * Math.pow(2, 20), // AWS rules; 5MiB is min size.

              enabled: true,
              mandatory: false,
            },
            fineUploaderOptions.chunking
          ),

          retry: _.extend(
            {
              enableAuto: true,
              autoAttemptDelay: 8,
              maxAutoAttempts: 4,
            },
            fineUploaderOptions.retry
          ),

          objectProperties: _.extend(
            {
              bucket: this.getConfigValue('aws.s3.{}.bucket'),
              region: this.getConfigValue('aws.s3.{}.region'),
            },
            fineUploaderOptions.objectProperties
          ),

          button: this.view.el,

          callbacks: _.extend({}, callbacks, {
            onTotalProgress: function() {
              var args = _.toArray(arguments);
              self.view.triggerMethod.apply(self.view, ['total:upload:progress', self.view].concat(args));
              if (callbacks.onTotalProgress) {
                callbacks.onTotalProgress.apply(this, arguments);
              }
            },
            onAllComplete: function() {
              var args = _.toArray(arguments);
              self.view.triggerMethod.apply(self.view, ['all:uploads:complete', self.view].concat(args));
              if (callbacks.onAllComplete) {
                callbacks.onTotalProgress.apply(this, arguments);
              }
            },
            onComplete: function() {
              var args = _.toArray(arguments);
              self.view.triggerMethod.apply(self.view, ['upload:complete', self.view].concat(args));
              if (callbacks.onComplete) {
                callbacks.onComplete.apply(this, arguments);
              }
            },
            onStatusChange: function() {
              var args = _.toArray(arguments);
              self.view.triggerMethod.apply(self.view, ['upload:status:change', self.view].concat(args));
              if (callbacks.onStatusChange) {
                callbacks.onStatusChange.apply(this, arguments);
              }
            },
            onSubmit: function() {
              var args = _.toArray(arguments);
              self.view.triggerMethod.apply(self.view, ['upload:submit', self.view].concat(args));
              if (callbacks.onSubmit) {
                callbacks.onSubmit.apply(this, arguments);
              }
            },
            onError: function() {
              var args = _.toArray(arguments);
              self.view.triggerMethod.apply(self.view, ['upload:error', self.view].concat(args));
              if (callbacks.onSubmit) {
                callbacks.onSubmit.apply(this, arguments);
              }
            },
          }),
        })
      );

      // the plan to handle file uploads
      // is to add a onSubmit callback
      // and then make an api call to create a file
      // once that is complete then we can call
      // this.setEndpoint(endpoint, fileId)
      // we can also call this.setUploadSuccessEndpoint(endpoint, fileId)
      // if we want to make a specific call when the upload has completed
      this.view.$el.addClass('fine-uploader-instance').data('fineUploaderInstance', this.fineUploader);
    },

    onTotalUploadProgress: function(view, totalUploadedBytes, totalBytes) {
      // Called during a batch of uploads, as they progress, but only for the AJAX uploader.
      // This represents the total progress of all files in the batch.
      this.getProgressDimmerViewStateModel().setProgress(totalUploadedBytes, totalBytes);
    },

    onAllUploadsComplete: function(view, succeededIds, failedIds) {
      // Called when all submitted items have reached a point of termination.
      // A file has reached a point of termination if it has been cancelled,
      // rejected, or uploaded (failed or successful).
      this.getProgressDimmerViewStateModel().setCompleted();
      this.hideProgressDimmerViewWithDelay();
    },

    onUploadComplete: function(view, fileId, fileName, responseJson, xhr) {
      // Called when the item has finished uploading
      this._requiresUploadBatchNotification = true;
    },

    onUploadError: function(view, fileId, name, err, xhr) {
      var fineUploader = this.fineUploader;
      if (err && err.xhr && this.isAccessDeniedStatus(err.xhr.status)) {
        fineUploader.pauseUpload(fileId);
        _.defer(function() {
          fineUploader.cancel(fileId);
        });
      }
    },

    onUploadSubmit: function(view, fileId) {
      if (this.fineUploader.getFile(fileId)) {
        var fileName = this.fineUploader.getFile(fileId).name;
        this.showProgressDimmerView();
        this.getProgressDimmerViewStateModel().clearState();
      }
    },

    onUploadStatusChange: function(view, fileId, oldStatus, status) {
      var file = this.fineUploader.getFile(fileId);
      var inProgressCount = this.fineUploader.getInProgress();
      var stateModel = this.getProgressDimmerViewStateModel();
      if (file && status == qq.status.UPLOADING) {
        if (inProgressCount <= 1) {
          stateModel.setCurrentItemText('Uploading "' + file.name + '"');
        }
      } else if (inProgressCount > 1) {
        stateModel.setCurrentItemText('Uploading ' + inProgressCount + ' files');
      } else if (inProgressCount < 1 && status == qq.status.CANCELED) {
        stateModel.setFailed();
        stateModel.setProgress(1, 1);
        stateModel.setCurrentItemText('Uploading failed.');
        this.hideProgressDimmerViewWithDelay(1000);
      }
    },

    isAccessDeniedStatus: function(status) {
      return status == 401 || status == 403;
    },

    getConfigValue: function(configPath) {
      var instanceName = this.getOption('name');
      var value;
      if (instanceName) {
        value = config.get(String(configPath).replace('{}', instanceName));
      }
      if (value == null) {
        value = config.get(String(configPath).replace('{}', 'defaults'));
      }
      return value;
    },

    getProgressDimmerView: function() {
      var self = this;
      if (!this._progressDimmerView) {
        this._progressDimmerView = this.view.buildComponent(
          _.extend(
            {
              type: ProgressModalView,
              progressControlInterface: {
                pause: function() {
                  self.pauseUploads();
                },
                resume: function() {
                  self.resumeUploads();
                },
                cancel: function() {
                  self.cancelAllUploads();
                  self.hideProgressDimmerView();
                },
              },
              visible: false,
            },
            Mn._getValue(this.getOption('modalOptions'), this)
          )
        );
        this.listenTo(this._progressDimmerView, 'modal:hide', function() {
          if (this._requiresUploadBatchNotification) {
            // indicates that of the newly started batch of uploads
            // at least one was successful
            this._requiresUploadBatchNotification = false;
            this.view.triggerMethod('upload:batch:complete', this.view);
          }
        });
        this.listenTo(this._progressDimmerView, 'modal:hidden', function() {
          this._progressDimmerView.destroy();
          this._progressDimmerView = null;
        });
      }
      return this._progressDimmerView;
    },

    pauseUploads: function() {
      _.each(
        this.fineUploader.getUploads({
          status: [qq.status.UPLOADING, qq.status.UPLOAD_RETRYING],
        }),
        function(file) {
          this.fineUploader.pauseUpload(file.id);
        },
        this
      );
    },

    resumeUploads: function() {
      _.each(
        this.fineUploader.getUploads({
          status: qq.status.PAUSED,
        }),
        function(file) {
          this.fineUploader.continueUpload(file.id);
        },
        this
      );
    },

    cancelAllUploads: function() {
      this.fineUploader.cancelAll();
    },

    showProgressDimmerView: function() {
      var progressModalView = this.getProgressDimmerView();
      progressModalView.visible = true;
      return progressModalView;
    },

    hideProgressDimmerViewWithDelay: function(delay) {
      var self = this;
      setTimeout(function() {
        self.hideProgressDimmerView();
      }, delay || 500);
    },

    hideProgressDimmerView: function() {
      var progressModalView = this.getProgressDimmerView();
      progressModalView.visible = false;
      return progressModalView;
    },

    getProgressDimmerViewStateModel: function() {
      return this.getProgressDimmerView().getState('main');
    },
  });

  module.exports = SelectAndUploadFilesBehavior;
});

